import { AppFeature } from "../data/appFeatures";

interface Props {
  feature: AppFeature;
}

export const AppFeatureCard = ({ feature }: Props) => {
  return (
    <article
      className={[
        "flex shrink-0 flex-col gap-4 rounded-[32px] bg-[#F5FAFA]",
        "h-[226px] w-[236px] p-6",
        "md:h-[256px] md:w-[291px] md:p-8",
      ].join(" ")}
    >
      <img
        src={feature.iconUrl}
        alt=""
        aria-hidden
        className="h-12 w-12 shrink-0"
      />
      <div className="flex flex-col gap-1 text-[#0D0D0D]">
        <h3 className="text-[16px] font-bold leading-[1.2] md:text-[19px]">
          {feature.title}
        </h3>
        <p className="text-[13px] leading-[1.6] tracking-[0.26px] md:text-[16px] md:tracking-normal">
          {feature.description}
        </p>
      </div>
    </article>
  );
};
